import { Injectable } from '@angular/core';
import { ODataApiDataService } from 'app/core/storage/odata-api-data.service';
import { Address, PhoneNumber } from 'odq-toolbox';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { ProfessionalDomicileAddress } from './member-professional-domicile.model';

const API_URL = environment.projectionQueryApi;

@Injectable({
  providedIn: 'root',
})
export class MemberProfessionalDomicileQueryService {
  constructor(private dataService: ODataApiDataService<any>) { }

  list(memberId: string): Observable<ProfessionalDomicileAddress[]> {
    return this.dataService
      .odataList(`${API_URL}/memberProfessionalDomiciles?$filter=MemberId eq ${memberId}&$orderby=EffectiveOn desc`)
      .pipe(
        map(res =>
          res.map(item => ({
            id: item.Id,
            effectiveOn: new Date(item.EffectiveOn),
            isCurrent: item.IsCurrent,
            phone: new PhoneNumber(item.PhoneCountryCode ?? 1, item.PhoneNumber, item.PhoneExt),
            fax: new PhoneNumber(item.FaxCountryCode ?? 1, item.FaxNumber, item.FaxExt),
            address: new Address(
              item.NormalizeId,
              item.Line1,
              item.Line2,
              item.City,
              item.ProvinceCode,
              item.PostalCode,
              item.CountryCode,
            ),
            practiceType: item.WorkAddressType,
            practiceSince: null,
            isInCompany: false,
            wheelchairAccess: item.WheelchairAccess,
            workAddressId: item.WorkAddressId,
            residenceId: item.ResidenceId,
            clinicName: item.ClinicName,
          })),
        ),
      );
  }
}
